var $j = jQuery.noConflict();

function loadComponent(containerId, fileName) {
    fetch(fileName)
        .then(response => response.text())
        .then(data => document.getElementById(containerId).innerHTML = data);
}

function showSurveyResult() {
  const errorEl = document.getElementById("errorMessage");
  const productButton = document.getElementById("product-button");
  const surveyResultImage = document.getElementById("surveyResultImage");
  const colorCombinationText = document.getElementById("colorCombinationText");
  const reasonEl = document.getElementById("recommendationReason");
  const surveyResultDiv = document.getElementById("surveyResult");
  const loadingVideo = document.getElementById("loadingVideo");

  errorEl.style.display = "none";

  const q1Input = document.querySelector('input[name="q1"]:checked');
  const q2Input = document.querySelector('input[name="q2"]:checked');
  const q3Input = document.querySelector('input[name="q3"]:checked');

  if (!q1Input || !q2Input || !q3Input) {
    errorEl.innerText = "すべての質問を選択してください。";
    errorEl.style.display = "block";
    return;
  }

  const q1 = q1Input.value;
  const q2 = q2Input.value;
  const q3 = q3Input.value;

  surveyResultImage.style.display = "none";
  colorCombinationText.style.display = "none";
  reasonEl.style.display = "none";
  productButton.style.display = "none";
  surveyResultDiv.style.display = "block";

  surveyResultDiv.scrollIntoView({ behavior: "smooth", block: "start" });

  // 動画再生開始
  loadingVideo.style.display = "block";
  loadingVideo.style.opacity = "0"; // 念のため初期化
  setTimeout(() => {
  loadingVideo.style.opacity = "1";
  }, 10);
  loadingVideo.currentTime = 0;
  loadingVideo.play();

  let apiResponse = null;
  let preloadImg = null;
  let imageReady = false;

  // APIと画像読み込みを先行実行
  const apiPromise = fetch(`https://5ma5no5nt0.execute-api.ap-northeast-1.amazonaws.com/prod/survey/ai-image?version=2&q1=${q1}&q2=${q2}&q3=${q3}`)
    .then(res => {
      if (!res.ok) throw new Error(`HTTPエラー: ${res.status}`);
      return res.json();
    })
    .then(data => {
      if (!data.imageUrl || !data.urlHandle || !data.variantId) {
        throw new Error("APIレスポンスが不正です。");
      }
      apiResponse = data;

      // 画像を事前に読み込み
      preloadImg = new Image();
      preloadImg.src = data.imageUrl;
      preloadImg.onload = () => {
        imageReady = true;
      };
    })
    .catch(err => {
      console.error("API Error:", err);
      errorEl.innerText = "データ取得に失敗しました。しばらくしてから再度お試しください。";
      errorEl.style.display = "block";
      loadingVideo.style.display = "none";
    });

  // 動画終了時の処理
  loadingVideo.onended = async function () {
    loadingVideo.style.display = "none";

    try {
      await apiPromise;

      // 画像の読み込みが終わってなければ待つ
      if (!imageReady) {
        await new Promise(resolve => {
          const interval = setInterval(() => {
            if (imageReady) {
              clearInterval(interval);
              resolve();
            }
          }, 50);
        });
      }

      // 表示（フェードイン）
      surveyResultImage.src = preloadImg.src;
      surveyResultImage.style.opacity = 0;
      surveyResultImage.style.display = "block";
      setTimeout(() => surveyResultImage.style.opacity = 1, 10);

      colorCombinationText.innerText = apiResponse.colorCombinations;
      colorCombinationText.style.opacity = 0;
      colorCombinationText.style.display = "block";
      setTimeout(() => colorCombinationText.style.opacity = 1, 10);

      reasonEl.innerText = apiResponse.recommendationReason;
      reasonEl.style.opacity = 0;
      reasonEl.style.display = "block";
      setTimeout(() => reasonEl.style.opacity = 1, 10);

      productButton.setAttribute("onclick", `location.href='https://arol.tokyo/products/${apiResponse.urlHandle}?variant=${apiResponse.variantId}'`);
      productButton.style.opacity = 0;
      productButton.style.display = "block";
      setTimeout(() => productButton.style.opacity = 1, 10);

    } catch (err) {
      console.error("読み込み処理中にエラー:", err);
    }
  };
}
